<script>
  import {getContext} from 'svelte';
  import {numUtil} from '@/helper';
  import {PRIZE_COIN_NAME} from '../const';
  import {prizePoolLevels$} from '../stream';
  import lang from '../TradeCompetitionPage.lang';

  const LG = getContext('LG');

  export let value = 0;

  let width = '';

  $: width = calcWidth(value, $prizePoolLevels$);

  function calcWidth(value, prizePoolLevels) {
    const levelCount = prizePoolLevels.length;
    if (value === 0) {
      return '0';
    }
    for (let i = 1; i < prizePoolLevels.length - 1; i++) {
      const cur = prizePoolLevels[i].count;
      if (cur > value) {
        return `${(i / levelCount) * 100}%`;
      }
    }
    return '100%';
  }
</script>

<style>
  .progress {
    padding: 20px 0;
    width: 100%;
    color: #fff;
  }

  .progress-bar {
    position: relative;
    height: 15px;
    width: 100%;
    background: #303236;
  }

  .bar-value {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    background: #6ac2ff;
    transition: width 1s;
  }

  .progress-info {
    width: 100%;
  }

  .info-item {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
    width: 100%;
    height: 20px;
    font-size: 16px;
  }

  .info-milestone {
    position: relative;
  }

  .info-milestone.active {
    color: #6ac2ff;
  }

  .milestone-label {
    text-align: left;
    white-space: nowrap;
  }

  .info-label {
    position: relative;
  }
</style>

<div class="progress">
  <div class="progress-bar">
    <div class="bar-value" style="width:{width};" />
  </div>
  <div class="progress-info">
    <div class="info-item">
      <div class="info-label f1 ovh">
        <div class="milestone-label ooo" style="left:0;">{LG(lang.Participants)}</div>
      </div>
      {#each $prizePoolLevels$.slice(1, $prizePoolLevels$.length - 1) as level, i}
        <div class="info-milestone f1 ovh" class:active={value >= $prizePoolLevels$[i].count && value < level.count}>
          <div class="milestone-label ooo">
            <i class="iconfont f10">&#xe63c;</i>
            &lt;{level.count}
          </div>
        </div>
      {/each}
      <div class="info-milestone f1 ovh" class:active={value >= $prizePoolLevels$[$prizePoolLevels$.length - 2].count}>
        <div class="milestone-label ooo">
          <i class="iconfont f10">&#xe63c;</i>
          &gt;={$prizePoolLevels$[$prizePoolLevels$.length - 2].count}
        </div>
      </div>
    </div>
    <div class="info-item">
      <div class="info-label f1 ovh">
        <div class="milestone-label ooo" style="left:0;">{LG(lang.PrizePool)}</div>
      </div>
      {#each $prizePoolLevels$.slice(1, $prizePoolLevels$.length - 1) as level, i}
        <div class="info-milestone f1 ovh" class:active={value >= $prizePoolLevels$[i].count && value < level.count}>
          <div class="milestone-label ooo">
            <i class="iconfont f10">&#xe63b;</i>
            {numUtil.delimit(level.prize)}
            {PRIZE_COIN_NAME}
          </div>
        </div>
      {/each}
      <div class="info-milestone f1 ovh" class:active={value >= $prizePoolLevels$[$prizePoolLevels$.length - 2].count}>
        <div class="milestone-label ooo">
          <i class="iconfont f10">&#xe63b;</i>
          {numUtil.delimit($prizePoolLevels$[$prizePoolLevels$.length - 1].prize)}
          {PRIZE_COIN_NAME}
        </div>
      </div>
    </div>
  </div>
</div>
